/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');
    
    app.directive('addthis', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            scope: {
                item: '=addthis',
            },            
            link: function (scope, element, attributes) {
                if (!window.addthis) {
                    return;
                }
                console.log('addthis', addthis, scope.item);
                addthis.layers.refresh();
                /*
                var config = {
                    'pubid': 'ra-5978b0f22e26faef',
                };
                var share = {
                    url: "THE URL",
                    title: "THE TITLE",
                    description: "THE DESCRIPTION",
                    media: "THE IMAGE",
                };
                addthis.share(element[0], config, share);
                */
            }
        };
    }]);

    /*
    app.directive('ctasFavourite', ['$log', '$timeout', function ($log, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'partials/ctas/favourite',
            scope: {},
            replace: true,
            link: function (scope, element, attrs) {
                scope.checked = false;
                function toggleFav() {
                    $timeout(function () {
                        scope.checked = !scope.checked;
                    }, 0);
                };
                element[0].addEventListener('click', toggleFav);
            }
        }
    }]);
    */

}());